export default __webpack_public_path__ + "static/media/comment-icon-new.8eacc91f.svg";